import { observer } from "mobx-react-lite";

import * as Profile from "@/components/auth/Profile";
import { useStore } from "@/store";
import { twMerge } from "@/utils/twMerge";

export const Header = observer(function Header() {
  const { dialog } = useStore();
  const { createTeamDialog } = dialog;
  const { team, step, formFields } = createTeamDialog;

  const permalink = team?.permalink || "";
  let title = team?.title || "";
  if (step !== "title" && formFields.title.value) {
    title = formFields.title.value;
  }

  return (
    <div className={twMerge("flex flex-row items-center p-10", "sm:p-4")}>
      <div className="flex flex-row items-center">
        {team?.avatarUrls?.[120] ? (
          <Profile.Userpic
            src={team.avatarUrls?.[120]}
            name={team.title || ""}
            setColorFrom={team.uid}
            className="w-10 h-10"
          />
        ) : (
          <Profile.Logo />
        )}
        <div className="flex flex-col ml-3">
          {title && (
            <div className="text-[16px] leading-[16px] font-geist font-semibold tracking-tighter">
              {title}
            </div>
          )}
          {permalink && (
            <div className="text-[13px] leading-[16px] font-geist font-normal text-gray-500 tracking-tighter">
              @{permalink}
            </div>
          )}
        </div>
      </div>
    </div>
  );
});
